import { render, staticRenderFns } from "./CreateProfessionalGroup.vue?vue&type=template&id=3fd3bf17&"
import script from "./CreateProfessionalGroup.vue?vue&type=script&lang=js&"
export * from "./CreateProfessionalGroup.vue?vue&type=script&lang=js&"
import style0 from "./CreateProfessionalGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports